// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import store from './store/index'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/common.css'
import './assets/iconfont/iconfont.css';
import './axios'
import '@wangeditor/editor/dist/css/style.css'

let docWidth=document.documentElement.clientWidth
if(docWidth<800){
  window.isPc=false
}else{
  window.isPc=true
}

Vue.config.productionTip = false
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js